<template>
  <div class="bottom-footer-container">
    <div style=" background: #222B43;margin-bottom: 1px;">
    <div class="flexr align_start justify_between width_auto bottom-footer-link " >
      <ul class="quick_links flexr align_start justify_between "  >
        <li v-for="(item,index) in tabList" :key="index">
          <p class="quick_links_title">{{ item.navName }}</p>
          <p @click="gotoPage(item,child)" v-for="(child,ci) in item.children" :key="ci">{{ child.navName }}</p>
        </li>

      </ul>
<!--      <div class="qrcode_box">-->
<!--        <h6 class="quick_links_title">公众号</h6>-->
<!--        <img src="@/assets/images/home/home5.png">-->
<!--        <p>扫码关注</p>-->
<!--      </div>-->
<!--      <div class="qrcode_box">-->
<!--        <h6 class="quick_links_title">视频号</h6>-->
<!--        <img src="@/assets/images/home/home6.png">-->
<!--        <p>扫码关注</p>-->
<!--      </div>-->
      <div class="contact_information">
        <h6 class="quick_links_title">联系方式</h6>
        <div class="flexr align_start"> <span class="contact_name"> <i class="el-icon-location-outline"></i>地址： </span><p>湖北省武汉市东湖新技术开发区高新二路41号8栋光谷建设大厦22层</p> </div>

<!--        <div class="flexr align_start"> <span class="contact_name"> <i class="el-icon-postcard"></i>邮编： </span><p>430074</p> </div>-->
<!--        <div class="flexr align_start"> <span class="contact_name"> <i class="el-icon-message"></i>邮箱： </span><p>ggnyyx@163.com</p> </div>-->
        <div class="flexr align_start"> <span class="contact_name"> <i class="el-icon-phone-outline"></i>电话： </span><p>027-81732062</p> </div>
      </div>
    </div>
    </div>
    <div class="bottom-footer flexr justify_center">
      <p class="flexr">版权所有：武汉光谷水资绿能投资有限公司<span style="display: inline-block;width: 43px;">  </span>
        鄂ICP备17016357号-3 <span style="display: inline-block;width: 43px;">  </span> <img style="width: 15px;height: 15px;margin-right: 5px;" src="@/assets/images/20.png"> 鄂公网安备42018502008369号</p>
    </div>
  </div>

</template>

<script>
import {navbarList} from "@/api";

export default {
  name: "bottomFooter",
  data(){
    return {
      tabList:[]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    gotoPage(item,child){
      this.$router.push({path:`${child.navSkip}/${item.categoryId}/${child.categoryId}`})
    },
    getList(){
      navbarList().then(res=>{
        this.tabList = res.map(item=>{
          let link=item.navSkip+'/'+item.categoryId+'/'+0
          return {
            ...item,
            navSkip:item.navSkip,
            link:link
          }
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.bottom-footer-container{


  .bottom-footer-link{
    padding:50px 0;

    .quick_links_title{
      font-size: 18px!important;
      margin-bottom: 15px;
      color: #FFFFFF;
      line-height: 25px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
    }
  }

}
.bottom-footer{
  height: 36px;
  background: #222B43;
  text-align: center;
  color: #fff;
  font-size: 12px;
  line-height:  36px;
  letter-spacing: 1px;
}
.quick_links{
  width: 55%;
  flex-shrink: 0;
  li{
    p{

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 25px;
      text-transform: none;
      margin-bottom: 6px;
      cursor: pointer;
      &:hover{
        color: #255aa7;
      }

    }

  }
}
.qrcode_box{
  //margin-left: 10%;
  img{
    width: 76px;
    height: 76px;
  }
  p{
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    margin-top: 10px;
  }
}
.contact_information{
  width: 30%;
  flex-shrink: 0;
  i{
    margin-right: 4px;
  }
  .contact_name{
    display: inline-block;
    width: 60px;
  }
p{
  width: calc(100% - 60px);
}
  span,p{
    padding-bottom: 10px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
  }
}

</style>
